"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var moment = require("moment");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var EditableNote = /** @class */ (function (_super) {
    __extends(EditableNote, _super);
    function EditableNote(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChange = function (event) {
            _this.setState({ editableNoteText: event.target.value });
        };
        _this.setEditableNoteValues = function () {
            _this.setState({ editableNoteText: "" });
            _this.props.setEditableNoteId("");
        };
        _this.updateNote = function () {
            var regex = /[^\s]/g;
            if (regex.test(_this.state.editableNoteText)) {
                var data = { text: _this.state.editableNoteText };
                _this.supportPortalService.updateNote(_this.props.customerReferenceNumber, _this.props.note.id, data).subscribe(function (note) {
                    _this.setState({ editableNoteText: "" });
                    _this.props.setEditableNoteId("");
                    _this.props.updateNotes();
                });
            }
            else {
                _this.setState({ editableNoteText: "" });
            }
        };
        _this.state = {
            editableNoteText: _this.props.note.text
        };
        return _this;
    }
    EditableNote.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "note", children: [(0, jsx_runtime_1.jsx)("textarea", { autoFocus: true, placeholder: "Type here . . .", className: "form-control note-textarea", value: this.state.editableNoteText, onChange: this.handleOnChange }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "note-created", children: [(0, jsx_runtime_1.jsxs)("div", { children: ["Created by: ", this.props.note.createdBy.fullName] }), (0, jsx_runtime_1.jsxs)("div", { children: ["Created on: ", moment().format("DD/MM/YYYY, HH:mm")] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "note-edit", children: [(0, jsx_runtime_1.jsx)("a", { className: "far fa-save note-icon", title: "Save", onClick: this.updateNote }), (0, jsx_runtime_1.jsx)("a", { className: "far fa-window-close note-icon", title: "Undo", onClick: this.setEditableNoteValues })] })] })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], EditableNote.prototype, "supportPortalService", void 0);
    EditableNote = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], EditableNote);
    return EditableNote;
}(React.Component));
exports.default = EditableNote;
//# sourceMappingURL=EditableNote.js.map